import Seo from "./../seo";
import Header from "./../header";
import Footer from "./../footer";
import MainContainer from "./../../container/main";
function Layout(props) {
  const { children, title, withGrassFooter, withFixedItem } = props;
  return (
    <>
      <Seo title={title} />
      <Header />
      <MainContainer>{children}</MainContainer>
      <Footer withGrassFooter={withGrassFooter} withFixedItem={withFixedItem} />
    </>
  );
}

export default Layout;
